<template>
  <div class="content">
    <div class="search-area">
          <el-row :gutter="24">
            <el-col :span="5"><div class="search-area-div">账号:</div><el-input v-model="page.logonUser" class="ipt-sty" placeholder="请输入账号"></el-input></el-col>
            <el-col :span="5"><div class="search-area-div">手机号:</div><el-input v-model="page.mobileNo" class="ipt-sty" placeholder="请输入手机号"></el-input></el-col>
            <el-col :span="5">
            <div class="search-area-div">状态:</div>
                      <div class="radio-sty">
                            <el-radio v-model="page.bizState" label="Y">有效</el-radio>
                            <el-radio v-model="page.bizState" label="S">停用</el-radio>
                      </div>
            </el-col>
            <el-col :span="5">
                  <el-button size="medium" type="info" @click="getData(true)">搜索</el-button>
                  <el-button size="medium" type="danger" @click="empty">清空</el-button>
            </el-col>
          </el-row>
    </div>
    <div class="button-area">
        <el-button icon="el-icon-plus" size="medium" type="info" @click="add(1,'')">添加用户</el-button>
        <el-button size="medium" type="danger" @click="getDeleteData(1,'')">批量删除</el-button>
        <el-button plain size="medium">历史数据</el-button>
    </div>
    <div class=" back-color-fff" style="padding: 16px;">
    <el-table :data="tableData" @selection-change="handleSelectionChange" border style="width: 100%;" v-loading="tableLoading">
      <el-table-column type="selection" width="60" header-align="center" align="center"></el-table-column>
      <el-table-column label="序号" width="60" header-align="center" align="center">
        <template slot-scope="scope">
            {{scope.$index+1}}
            <!-- {{(page.pageIndex - 1) * page.pageSize + scope.$index + 1}} -->
        </template>
        </el-table-column>
      <el-table-column prop="logonUser" label="账号"  header-align="center" align="center"></el-table-column>
      <el-table-column prop="name" label="姓名" header-align="center" align="center"></el-table-column>
      <el-table-column prop="mobileNo" label="手机号" header-align="center" align="center"></el-table-column>
      <el-table-column prop="bizState" label="状态" header-align="center" align="center"></el-table-column>
      <el-table-column prop="createUserName" label="创建人" header-align="center" align="center"></el-table-column>
      <el-table-column prop="createTime" label="创建时间" sortable  header-align="center" align="center">
              <template slot-scope="scope">{{scope.row.createTime | getDate}}</template>
      </el-table-column>
      <el-table-column prop="updateTime" label="上次更新时间" sortable header-align="center" align="center">
              <template slot-scope="scope">{{scope.row.updateTime | getDate}}</template>
      </el-table-column>
      <el-table-column label="操作" header-align="center" align="center">
      <template slot-scope="scope">
        <a class="txt-color" @click="add(2,scope.row)">编辑 | </a>
        <a class="txt-color-red" @click="getDeleteData(2,scope.row.guid)">删除</a>
      </template>
    </el-table-column>
    </el-table>
    </div>
    <el-pagination
      class="pt pb back-color-fff"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 30, 50]"
      :current-page="page.pageIndex"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.totalRows">
    </el-pagination>
    <el-dialog :title="textTitle" :visible.sync="dialogFormVisible" width="550px">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" :label-position="right" class="demo-ruleForm">
        <el-form-item label="账号:" prop="number">
          <el-input v-model="ruleForm.number" autocomplete="off" class="w100f"></el-input>
        </el-form-item>
        <el-form-item label="密码:" prop="pwd">
          <el-input v-model="ruleForm.pwd" autocomplete="off" class="w100f"></el-input>
        </el-form-item>
        <el-form-item label="姓名:" prop="name">
          <el-input v-model="ruleForm.name" autocomplete="off" class="w100f"></el-input>
        </el-form-item>
        <el-form-item label="手机号:" prop="phone">
          <el-input v-model="ruleForm.phone" autocomplete="off" class="w100f"></el-input>
        </el-form-item>
        <el-form-item label="状态:" class="t-left">
          <el-radio v-model="ruleForm.state" label="Y">有效</el-radio>
          <el-radio v-model="ruleForm.state" label="S">停用</el-radio>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
         <el-button plain size="medium" @click="dialogFormVisible = false">取消</el-button>
         <el-button  size="medium" type="info" v-if="textTitle == '添加用户'" @click="submitForm('ruleForm')">确定</el-button>
         <el-button  size="medium" type="info" v-else @click="upDateForm('ruleForm')">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script> 
  export default {  
    data() {
      return {
        input:'',
        textTitle:'',
        right:'',
        dialogVisible: false,
        dialogFormVisible:false,
        formLabelWidth: '120px',
        ruleForm: {
          guid:'',
          number: '',
          pwd: '',
          name: '',
          phone: '',
          state:''
        },
         page:{
          pageIndex:1,
          pageSize:10,
          totalPage:0,
          totalRows:0,
          guid:'',
          logonUser:'',
          name:'',
          bizState:'Y',
          mobileNo:'',
          platformGuid:'',
          platformName:'',
          startTime:'', 
          endTime:'',
        }, 
         tableData: [],
          rules: {
                number: [
                  { required: true, message: '请输入账号', trigger: 'blur' },
                  { min: 1, max: 30, message: '长度在 3 到 5 个字符', trigger: 'blur' }
                ],
                pwd: [
                  { required: true, message: '请输入密码', trigger: 'blur' },
                  { min: 1, max: 60, message: '长度在 3 到 5 个字符', trigger: 'blur' }
                ],
                name: [
                  { required: true, message: '请输入姓名', trigger: 'blur' },
                  { min: 1, max: 30, message: '长度在 3 到 5 个字符', trigger: 'blur' }
                ],
                phone: [
                  { required: true, message: '请输入手机号', trigger: 'blur' },
                  { min: 1, max: 11, message: '长度在 3 到 5 个字符', trigger: 'blur' }
                ],
              },
          multipleSelection: [],
          tableLoading:false
      };
    },
    created(){
    // 列表
    this.getData(false); 
  },
    methods: {
      empty(){
        let self = this;
        self.page = {
          pageIndex:1,
          pageSize:10,
          totalPage:0,
          totalRows:0,
          guid:'',
          logonUser:'',
          name:'',
          bizState:'Y',
          mobileNo:'',
          platformGuid:'',
          platformName:'',
          startTime:'', 
          endTime:'',
        }
        self.getData(true); 
      },
      getData(flg) {
              let self = this;
              if(flg) {
                self.page.pageIndex = 1;
              }
              self.tableLoading = true;
              self.api.postJson(`/${serverConfig.msCommonAdminPlatformAuthService}/user/data/get`,self.page).then(res=>{ 
                     if(res.data.code == serverConfig.REQUIRE_SUCCESS_CODE){
                       self.tableLoading = false;
                          self.tableData = res.data.data.records;
                          self.tableData.forEach(function(item) { 
                            item.bizState = item.bizState == 'Y'?'有效':'停用'
                          });
                          self.page.totalPage = res.data.data.totalPages;
                          self.page.totalRows = res.data.data.totalRows;
                     }else {
                      self.$message.error(res.data.msg);
                     } 
              }) 
      },
      handleSelectionChange(val) {
          let self = this;
          self.multipleSelection = [];
          val.forEach(function(item) {
              //item 就是当日按循环到的对象
              self.multipleSelection.push(item.guid);
          }) 
      },

      getDeleteData(flg,guid) {
              let self = this;
              if(flg == 1){
                      if(self.multipleSelection.length == 0){
                            self.$message.error("请勾选数据！");
                    }
              }else {
                    self.multipleSelection = [];
                    self.multipleSelection.push(guid);
              }
              this.$confirm('此操作将永久删除, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                self.api.postJson(`/${serverConfig.msCommonAdminPlatformAuthService}/user/data/delete`,self.multipleSelection).then(res=>{ 
                     if(res.data.code == serverConfig.REQUIRE_SUCCESS_CODE){
                            self.multipleSelection = [];
                            self.$message.success('删除用户成功');
                            self.getData(true); 
                     }else {
                            self.$message.error(res.data.msg);
                     } 
              }) 
              }).catch(() => {
                this.$message({
                  type: 'info',
                  message: '已取消删除'
                });          
              }); 
      },
      add(flg,row){
        let self = this;
        if(flg == 1){
            self.textTitle = "添加用户";
            self.ruleForm.number = '';
            self.ruleForm.pwd = '';
            self.ruleForm.name = '';
            self.ruleForm.phone = '';
            self.ruleForm.state = '';
        }else{
            self.textTitle = "编辑用户";
            self.ruleForm.guid = row.guid;
            self.ruleForm.number = row.logonUser;
            self.ruleForm.pwd = row.pwd;
            self.ruleForm.name = row.name;
            self.ruleForm.phone = row.mobileNo;
            self.ruleForm.state = row.bizState == '有效'?'Y':'S';
        }
        this.dialogFormVisible = true
      },
      submitForm(formName) {
        let self = this;
        self.$refs[formName].validate((valid) => {
          if (valid) {
                let promise = {
                      'logonUser':self.ruleForm.number,
                      'pwd':self.ruleForm.pwd,
                      'name':self.ruleForm.name,
                      'bizState':self.ruleForm.state,
                      'mobileNo':self.ruleForm.phone
                }
                self.api.postJson(`/${serverConfig.msCommonAdminPlatformAuthService}/user/data/add`,promise).then(res=>{ 
                       if(res.data.code == serverConfig.REQUIRE_SUCCESS_CODE){
                              self.dialogFormVisible = false;
                              self.$message.success('添加用户成功');
                              self.getData(true); 
                       }else {
                              self.$message.error(res.data.msg);
                       } 
                }) 
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      upDateForm(formName) {
        let self = this;
        self.$refs[formName].validate((valid) => {
          if (valid) {
                let promise = {
                      'guid':self.ruleForm.guid,
                      'logonUser':self.ruleForm.number,
                      'pwd':self.ruleForm.pwd,
                      'name':self.ruleForm.name,
                      'bizState':self.ruleForm.state,
                      'mobileNo':self.ruleForm.phone
                }
                self.api.put(`/${serverConfig.msCommonAdminPlatformAuthService}/user/data/update`,promise).then(res=>{ 
                       if(res.data.code == serverConfig.REQUIRE_SUCCESS_CODE){
                              self.dialogFormVisible = false;
                              self.$message.success('编辑用户成功');
                              self.getData(true); 
                       }else {
                              self.$message.error(res.data.msg);
                       } 
                }) 
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
      handleSizeChange(val) {
        let self = this;
        self.page.pageSize = val;
        this.getData();
      },
      handleCurrentChange(val) { 
        let self = this;
        self.page.pageIndex = val;
        this.getData();
      }
    },
  };
</script>
